module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header', [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header-title', {
    attrs: {
      "title": "Page Not Found"
    }
  })], 1)]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body",
    attrs: {
      "id": "copy"
    }
  }, [_c('h1', [_vm._v("Oops! We couldn't find the page you are looking for.")]), _vm._v(" "), _c('h2', [_vm._v("We're doing a remodel, so the page may be here the next time you visit.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52c305af","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = 916
// module chunks = 1